import { createFileRoute } from "@tanstack/react-router";
import { Kosten } from "../features/shell/Kosten";

export const Route = createFileRoute("/kosten")({
  component: Kosten,
});
